export default __webpack_public_path__ + "static/media/TotalEarningsIcon.9eaf6870.svg";